<!-- Hero Competition -->
<div class="mb-8 mt-5">
  <app-competition-jumbotron [competition]="competition"></app-competition-jumbotron>
</div>

<div class="content" [ngClass]="{'transition-ready': transitionReady}">
  <!-- Storyboard dashboard -->
  <div class="mb-8">
    <app-storyboard-dashboard></app-storyboard-dashboard>
  </div>

  <!-- Topics dashboard -->
  <div class="mb-8">
  <app-topics-dashboard></app-topics-dashboard>
  </div>


  <!-- Useful links daskboard -->
  <div class="mb-8">
  <app-useful-links-dashboard></app-useful-links-dashboard>
  </div>

  <footer class="mb-5 text-center text-secondary">
    <div class="footer-image mb-4" *ngIf="footerImageSrc">
      <img [src]="footerImageSrc" alt="Footer image" />
    </div>
    <p ><span class='text-uppercase'>© {{date | date:'yyy'}} UEFA. All rights reserved.</span> The various graphical, brand and other materials (including logos, official marks and footage) featured in these guidelines have been created for use in connection with UEFA’s competitions (“UEFA Materials”) and are protected by international intellectual property laws.</p>
    <p>These UEFA Materials can only be used by parties who have been granted the necessary rights by UEFA in respect of the UEFA Nations League, and may only be used to the extent necessary to exercise those rights in accordance with their rights agreement.</p>
    </footer>
</div>
